import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from './form';

export default {
  extends: TablePage,
  components: { Form },
  data() {
    return {
      requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('page_list');
  },
  methods: {
    // 弹框操作
    modalClick({ val, row }) {
      // 启用禁用
      if (val.code === 'enable' || val.code === 'disable') {
        if (!this.selection || this.selection.length === 0) {
          return this.$message.error('请至少选择一条数据');
        }
        request.post(`/tpm/tpmRewardPoolRule/${val.code}`, this.selection).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.getList();
          }
        });
      }
      // 新增
      if (val.code === 'add') {
        this.formConfig = {
          code: val.code,
        };
        this.modalConfig.title = '新增奖励规则';
        this.openFull();
      }
      if (val.code === 'view' || val.code === 'edit') {
        this.formConfig = {
          code: val.code,
          row,
        };
        this.modalConfig.title = val.title;
        this.openFull();
      }
    },
  },
};
